<div class="contact-page-wrapper">
  <!-- Minimal Top Header Bar -->
  <header class="contact-header">
    <div class="header-container">
      <a class="brand-logo-link" (click)="goBackHome()">
        <img src="assets/images/new-logo.png" alt="Certiplate Logo" class="brand-logo-img" />
      </a>
      <button class="btn-back-home" (click)="goBackHome()">
        <span>← Back to Home</span>
      </button>
    </div>
  </header>

  <main class="contact-main-container">
    <div class="contact-content-grid">
      
      <!-- TOP ROW: Send us a Message (Left Card) & Quick Contact (Right Card) -->
      <div class="top-row-grid">
        
        <!-- Send us a Message Card -->
        <div class="contact-card message-card">
          <h2 class="card-title">Send us a Message</h2>
          <p class="card-subtitle">Your message goes directly to our team. Share your requirements and we'll connect you with the right person.</p>

          <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
            <!-- Full Name & Email -->
            <div class="form-row two-col">
              <div class="field-group">
                <label class="field-label">FULL NAME*</label>
                <input
                  type="text"
                  formControlName="fullName"
                  placeholder="John Doe"
                  class="form-control-emerald"
                  [ngClass]="{ 'is-invalid': contactForm.get('fullName')?.touched && contactForm.get('fullName')?.invalid }"
                />
                <div *ngIf="contactForm.get('fullName')?.touched && contactForm.get('fullName')?.invalid" class="invalid-feedback">
                  Full name is required.
                </div>
              </div>

              <div class="field-group">
                <label class="field-label">EMAIL*</label>
                <input
                  type="email"
                  formControlName="email"
                  placeholder="johndoe@example.com"
                  class="form-control-emerald"
                  [ngClass]="{ 'is-invalid': contactForm.get('email')?.touched && contactForm.get('email')?.invalid }"
                />
                <div *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.invalid" class="invalid-feedback">
                  Valid email is required.
                </div>
              </div>
            </div>

            <!-- Phone & Company -->
            <div class="form-row two-col">
              <div class="field-group">
                <label class="field-label">PHONE*</label>
                <input
                  type="tel"
                  formControlName="phone"
                  placeholder="+91 88884 44605"
                  class="form-control-emerald"
                  [ngClass]="{ 'is-invalid': contactForm.get('phone')?.touched && contactForm.get('phone')?.invalid }"
                />
                <div *ngIf="contactForm.get('phone')?.touched && contactForm.get('phone')?.invalid" class="invalid-feedback">
                  Phone number is required.
                </div>
              </div>

              <div class="field-group">
                <label class="field-label">COMPANY*</label>
                <input
                  type="text"
                  formControlName="company"
                  placeholder="Navriti Technologies"
                  class="form-control-emerald"
                  [ngClass]="{ 'is-invalid': contactForm.get('company')?.touched && contactForm.get('company')?.invalid }"
                />
                <div *ngIf="contactForm.get('company')?.touched && contactForm.get('company')?.invalid" class="invalid-feedback">
                  Company name is required.
                </div>
              </div>
            </div>

            <!-- Inquiry Type Dropdown -->
            <div class="form-row single-col">
              <div class="field-group">
                <label class="field-label">INQUIRY TYPE</label>
                <div class="select-wrapper">
                  <select formControlName="inquiryType" class="form-control-emerald select-emerald">
                    <option *ngFor="let type of inquiryTypes" [value]="type">{{ type }}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Message Textarea -->
            <div class="form-row single-col">
              <div class="field-group">
                <label class="field-label">MESSAGE*</label>
                <textarea
                  formControlName="message"
                  rows="4"
                  placeholder="Tell us about your requirements..."
                  class="form-control-emerald textarea-emerald"
                  [ngClass]="{ 'is-invalid': contactForm.get('message')?.touched && contactForm.get('message')?.invalid }"
                ></textarea>
                <div *ngIf="contactForm.get('message')?.touched && contactForm.get('message')?.invalid" class="invalid-feedback">
                  Please enter at least 10 characters.
                </div>
              </div>
            </div>

            <!-- Status Alert Banner -->
            <div *ngIf="statusMessage" class="status-alert" [ngClass]="statusType">
              {{ statusMessage }}
            </div>

            <!-- Submit Button -->
            <div class="submit-row">
              <button type="submit" class="btn-send-message" [disabled]="isSubmitting">
                <span *ngIf="!isSubmitting">✈ Send Message</span>
                <span *ngIf="isSubmitting">Sending...</span>
              </button>
            </div>
          </form>
        </div>

        <!-- Quick Contact Card -->
        <div class="contact-card quick-contact-card">
          <h2 class="card-title">Quick Contact</h2>
          <p class="card-subtitle">Our team is available across multiple channels for your queries, pick the one which suits you the best.</p>

          <div class="quick-info-list">
            <!-- Call Us Section -->
            <div class="quick-info-block">
              <div class="block-head">
                <span class="block-icon icon-emerald">📞</span>
                <h3 class="block-title">Call Us</h3>
              </div>
              <div class="contact-detail-grid">
                <div class="detail-pair">
                  <span class="detail-label">General Inquiries</span>
                  <a href="tel:+916200147904" class="detail-value green-link">+91 6200147904</a>
                </div>
                <div class="detail-pair">
                  <span class="detail-label">Grievance</span>
                  <a href="tel:+919880456565" class="detail-value green-link">+91 9880456565</a>
                </div>
                <div class="detail-pair">
                  <span class="detail-label">Tech Support</span>
                  <a href="tel:+917787084755" class="detail-value green-link">+91 7787084755</a>
                </div>
                <div class="detail-pair">
                  <span class="detail-label">Sales</span>
                  <a href="tel:+919739461857" class="detail-value green-link">+91 9739461857</a>
                </div>
              </div>
            </div>

            <!-- Email Us Section -->
            <div class="quick-info-block">
              <div class="block-head">
                <span class="block-icon icon-emerald">✉</span>
                <h3 class="block-title">Email Us</h3>
              </div>
              <div class="contact-detail-grid emails-grid">
                <div class="detail-pair">
                  <span class="detail-label">Sales Inquiries</span>
                  <span class="detail-value green-link">sales@certiplate.com</span>
                </div>
                <div class="detail-pair">
                  <span class="detail-label">Support</span>
                  <span class="detail-value green-link">support@certiplate.com</span>
                </div>
                <div class="detail-pair">
                  <span class="detail-label">General</span>
                  <span class="detail-value green-link">info@certiplate.com</span>
                </div>
                <div class="detail-pair">
                  <span class="detail-label">Grievance</span>
                  <span class="detail-value green-link">grievance@certiplate.com</span>
                </div>
              </div>
            </div>

            <!-- Office Hours Section -->
            <div class="quick-info-block">
              <div class="block-head">
                <span class="block-icon icon-emerald">🕒</span>
                <h3 class="block-title">Office Hours</h3>
              </div>
              <div class="hours-schedule">
                <div class="hours-row">
                  <span class="hours-day">Monday - Friday</span>
                  <span class="hours-time">9:00 AM - 6:00 PM</span>
                </div>
                <div class="hours-row">
                  <span class="hours-day">Saturday</span>
                  <span class="hours-time">9:00 AM - 2:00 PM</span>
                </div>
                <div class="hours-row">
                  <span class="hours-day">Sunday</span>
                  <span class="hours-time text-muted">Office Remains Closed</span>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- BOTTOM ROW: Company Office Card -->
      <div class="contact-card company-office-card">
        <h2 class="card-title text-center">Company Office</h2>
        <p class="card-subtitle text-center">Our offices are open and our teams are ready to assist you. Stop by any branch at your convenience using the details below.</p>

        <div class="office-branches-grid">
          <!-- Bangalore Corporate Office -->
          <div class="branch-card">
            <div class="branch-head">
              <span class="branch-icon">📍</span>
              <div>
                <h3 class="branch-city">Bangalore</h3>
                <span class="branch-tag">Corporate Office</span>
              </div>
            </div>
            <p class="branch-address">
              Navriti Technologies Private Limited<br>
              9, PID No. 55-180-9, 100 Feet Ring Road,<br>
              Banashankari, BSK 2nd Stage,<br>
              Bangalore - 560070
            </p>
            <div class="branch-meta">
              <span>Location Link: <a href="https://www.google.com/maps/search/?api=1&query=Navriti+Technologies+Private+Limited,+9,+100+Feet+Ring+Road,+BSK+2nd+Stage,+Bangalore+560070" target="_blank" rel="noopener noreferrer" class="green-link">View on Google Maps</a></span>
              <span>Phone No: <a href="tel:+919880456565" class="green-link">+91 9880456565</a></span>
            </div>
            <div class="branch-actions">
              <a href="https://www.google.com/maps/search/?api=1&query=Navriti+Technologies+Private+Limited,+9,+100+Feet+Ring+Road,+BSK+2nd+Stage,+Bangalore+560070" target="_blank" rel="noopener noreferrer" class="btn-branch btn-direction"><span>📍 Direction</span></a>
              <a href="tel:+919880456565" class="btn-branch btn-call"><span>📞 Call</span></a>
            </div>
          </div>

          <!-- Noida Branch Office -->
          <div class="branch-card">
            <div class="branch-head">
              <span class="branch-icon">📍</span>
              <div>
                <h3 class="branch-city">Noida</h3>
                <span class="branch-tag">Branch Office</span>
              </div>
            </div>
            <p class="branch-address">
              Navriti Technologies Private Limited<br>
              A-75, 1st Floor, Sector 5,<br>
              Noida, Uttar Pradesh - 201301
            </p>
            <div class="branch-meta">
              <span>Location Link: <a href="https://www.google.com/maps/search/?api=1&query=Navriti+Technologies+Private+Limited,+A-75,+Sector+5,+Noida,+Uttar+Pradesh+201301" target="_blank" rel="noopener noreferrer" class="green-link">View on Google Maps</a></span>
              <span>Phone No: <a href="tel:+919811235593" class="green-link">+91 9811235593</a></span>
            </div>
            <div class="branch-actions">
              <a href="https://www.google.com/maps/search/?api=1&query=Navriti+Technologies+Private+Limited,+A-75,+Sector+5,+Noida,+Uttar+Pradesh+201301" target="_blank" rel="noopener noreferrer" class="btn-branch btn-direction"><span>📍 Direction</span></a>
              <a href="tel:+919811235593" class="btn-branch btn-call"><span>📞 Call</span></a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>

  <!-- Footer matching Site Pages -->
  <footer class="site-footer">
    <div class="footer-bar-container">
      <div class="footer-content-row">
        <!-- Logo on Left -->
        <a routerLink="/" class="footer-logo-link">
          <img src="assets/images/new-logo.png" alt="Certiplate Logo" class="footer-logo-img" />
        </a>

        <!-- Copyright Notice in Middle/Left -->
        <span class="copyright-text">@ 2026 Certiplate. All Rights Reserved by <a href="http://navriti.com"
            target="_blank" rel="noopener noreferrer" class="copyright-owner-link">NAVRITI TECHNOLOGIES PRIVATE LIMITED</a></span>

        <!-- Legal Links Group on Right -->
        <div class="legal-links-group">
          <a routerLink="/terms-and-conditions" class="legal-link-item">Terms and Conditions</a>
          <a routerLink="/privacy-policy" class="legal-link-item">Privacy</a>
          <a routerLink="/cookie-policy" class="legal-link-item">Cookies</a>
        </div>
      </div>
    </div>
  </footer>
</div>
